import { cache } from '@tencent/ppd-base-libs';

const CACHE_KEY = 'isShowTabTips';
const CACHE_TIME = 1000 * 60 * 60 * 24 * 365 * 10;

/** 是否展示过指定tab的tips */
export function isTabShowed(tabKey: string) {
  const showData = cache.getItemSync(CACHE_KEY) || {};
  return showData[tabKey];
}

/**
 * 标记该tab已展示过tips
 */
export function markShowedTabTips(tabKey: string) {
  const cacheData = cache.getItemSync(CACHE_KEY);
  cache.setItemSync(CACHE_KEY, {
    ...cacheData,
    [tabKey]: true,
  }, CACHE_TIME);
}
